<tvb-filter-box
  *ngIf="isThisSectionAvailable('category')"
  filterName="category"
  displayProperty="categoryName"
  accessProperty="categoryUrl"
  mainProperty="categories"
  title="Categories"
  inputPlaceholder="Categories"
  [options]="sections?.categories"
  [appConfig]="appConfig"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="categoryExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
></tvb-filter-box>

<tvb-filter-box
  *ngIf="isThisSectionAvailable('sub')"
  filterName="sub"
  displayProperty="subName"
  accessProperty="subUrl"
  mainProperty="subCategories"
  title="Sub Categories"
  inputPlaceholder="Sub Categories"
  [options]="sections?.subCategories"
  [appConfig]="appConfig"
  [isQuickSearchable]="true"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="subExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
></tvb-filter-box>

<tvb-filter-box
  *ngIf="isThisSectionAvailable('brand')"
  filterName="brand"
  displayProperty="brandName"
  accessProperty="brandUrl"
  mainProperty="brands"
  title="Designers"
  inputPlaceholder="Designers"
  [options]="sections?.brands"
  [appConfig]="appConfig"
  [isQuickSearchable]="true"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="brandExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
></tvb-filter-box>

<tvb-filter-box
  *ngIf="isThisSectionAvailable('style')"
  filterName="style"
  displayProperty="styleName"
  accessProperty="styleUrl"
  mainProperty="styles"
  title="Styles"
  inputPlaceholder="Styles"
  [options]="sections?.styles"
  [appConfig]="appConfig"
  [isQuickSearchable]="true"
  [isExpanded]="styleExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
></tvb-filter-box>

<tvb-filter-box
  *ngIf="sections?.colors"
  filterName="color"
  displayProperty="colorName"
  accessProperty="colorUrl"
  mainProperty="colors"
  title="Colors"
  inputPlaceholder="Colors"
  [options]="sections?.colors"
  [appConfig]="appConfig"
  [isQuickSearchable]="true"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="colorExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
></tvb-filter-box>

<tvb-filter-box
  *ngIf="sections?.conditions"
  filterName="condition"
  displayProperty="conditionName"
  accessProperty="conditionRating"
  mainProperty="conditions"
  title="Conditions"
  [options]="sections?.conditions"
  [appConfig]="appConfig"
  [isQuickSearchable]="false"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="conditionExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
>
  <ng-template #conditionsInfo>
    <i class="fa fa-info-circle ignore-click-outside" (click)="openConditionsInfo($event)"></i>
  </ng-template>
</tvb-filter-box>

<tvb-filter-box
  *ngIf="sections?.forYourBudget"
  filterName="price"
  displayProperty="title"
  accessProperty="price"
  title="For Your Budget"
  [options]="priceOptions"
  [appConfig]="appConfig"
  [isQuickSearchable]="false"
  [inputType]="FilterBoxInputTypeEnum.RADIOBUTTON"
  [isExpanded]="priceExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
>
  <ng-template #priceSlider>
    <input
      id="price-min-value"
      class="price-input"
      type="text"
      [value]="formatPrice(selectedMinPrice)"
      [disabled]="true"
    />
    <input
      id="price-max-value"
      class="price-input"
      type="text"
      [ngModel]="formatPrice(selectedMaxPrice)"
      [disabled]="true"
    />

    <div class="price-slider">
      <ngx-slider
        [(value)]="selectedMinPrice"
        [(highValue)]="selectedMaxPrice"
        [options]="priceSliderOptions"
        (userChangeEnd)="handlePriceSliderChange($event)"
      ></ngx-slider>
    </div>
  </ng-template>
</tvb-filter-box>

<tvb-filter-box
  *ngIf="discountOptions"
  filterName="discount"
  displayProperty="discountName"
  accessProperty="discountValue"
  title="Discounts"
  [options]="discountOptions"
  [appConfig]="appConfig"
  [isQuickSearchable]="false"
  [inputType]="FilterBoxInputTypeEnum.RADIOBUTTON"
  [isExpanded]="discountExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
></tvb-filter-box>

<tvb-filter-box
  *ngIf="sections?.shoes && isThisSectionAvailable('shoes')"
  filterName="shoes"
  displayProperty="shoesSize"
  accessProperty="shoesSize"
  mainProperty="shoes"
  title="Shoes Size"
  inputPlaceholder="Shoes Size"
  [options]="sections?.shoes"
  [appConfig]="appConfig"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="shoesExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
  [isQuickSearchable]="true"
>
  <ng-template #shoesSizeInfo>
    <i class="fa fa-info-circle ignore-click-outside" (click)="openShoesSizeInfo($event)"></i>
  </ng-template>
</tvb-filter-box>

<tvb-filter-box
  *ngIf="sections?.clothings && isThisSectionAvailable('clothing')"
  filterName="clothing"
  displayProperty="clothingSize"
  accessProperty="clothingSize"
  mainProperty="clothings"
  title="Clothing Sizes"
  inputPlaceholder="Clothing Sizes"
  [options]="sections?.clothings"
  [appConfig]="appConfig"
  [inputType]="FilterBoxInputTypeEnum.CHECKBOX"
  [isExpanded]="clothingExpanded ?? initExpanded"
  (toggleSectionOption)="handleOptionToggling($event)"
  [isQuickSearchable]="true"
>
  <ng-template #clothingSizeInfo>
    <i class="fa fa-info-circle ignore-click-outside" (click)="openClothingSizeInfo($event)"></i>
  </ng-template>
</tvb-filter-box>
